//*************** Show Quiz Result on load ***************/
const windowUrl = window.location.href;
const quizObj = sessionStorage.getItem("quizData");
if (windowUrl.indexOf("/pages/activation-offer") > -1 && windowUrl.indexOf("ContactFooter") > -1 && quizObj) {
  const banner = document.querySelector('[id*="bm_hero_banner"]')
  const quizLandingPage = document.querySelector('.quiz-landing-page')
  if(banner){
    banner.style.display = 'none'
  }
  if(quizLandingPage){
    quizLandingPage.style.display = 'block'
  }
  showResult();
}

/*************** Progress bar code ***************/
const progressBar = document.getElementById("progressBar");
const progressPoint = document.getElementById("progressPoint");
let progress = 0;
const step = 5; // Increase by 20% for each step
const maxProgress = 100;
function updateProgress(tabNumber) {
  const progress = (tabNumber / step) * maxProgress;
  progressBar.style.width = `${progress}%`;
  progressPoint.style.left = `${progress}%`;
}

/*************** Wizard tab switch code ***************/
const tabContents = document.querySelectorAll(".quiz-step-wrapper");
const tabsContentWrapper = document.querySelector(".quiz-steps-container");
const prevButton = document.querySelectorAll(".quiz-prev-btn");
const nextButton = document.querySelectorAll(".quiz-next-btn");
const quizOptionInput = document.querySelectorAll(".quiz-option input");
const quizButton = document.querySelectorAll(".quiz-option button");
const SubmitButton = document.querySelector(".quiz-submit-btn");
let customStep = 1;
let optionType;
let activeTab = 1; // Keep track of the active tab
var quiz_banner_button = document.querySelector(".activation-hero-banner .bm-button-primary");
quiz_banner_button.addEventListener("click", function (event) {
  event.preventDefault();
  document.querySelector(".activation-hero-banner").style.display = "none";
  document.querySelector(".quiz-landing-page").style.display = "block";
  updateActiveTab(activeTab);
});

var windowURL = window.location.href;

var count = 0;


async function sendDataToKlaviyo(quizData, recommendedTitles = []) {
  const email = quizData?.step_6 || quizData?.step_5 || ""; // fallback to step_5 if email is stored there
  if (!email) {
    console.warn("Email not found in quiz data.");
    return;
  }

  const API_URL = "https://a.klaviyo.com/client/profiles?company_id=TNCmQE";

  const properties = {
    ...quizData,
    quiz_recommended_products: recommendedTitles,
  };

  const payload = {
    data: {
      type: "profile",
      attributes: {
        email,
        properties,
      },
    },
  };

  const options = {
    method: "POST",
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      Revision: "2025-01-15",
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await fetch(API_URL, options);

    // Log the request payload
    console.log("Data Sent to Klaviyo:", payload);

    const text = await response.text(); // safely get raw text

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status} - ${response.statusText}`);
    }

    if (text) {
      const json = JSON.parse(text);
    } 
  } catch (error) {
    console.error("Klaviyo send error:", error.message);
  }
}



SubmitButton.addEventListener("click", function (event) {
    event.preventDefault();
    const newsletterButton = document.querySelector(".newsletter-form__button");
    const emailValue = document.querySelector(".newsletter-form__field-wrapper .field__input").value,
        emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(emailValue) && emailValue.length) {
        let quizData = JSON.parse(sessionStorage.getItem("quizData"));
        if (quizData) {
            quizData[`step_${customStep}`] = emailValue;
            sessionStorage.setItem("quizData", JSON.stringify(quizData));
            if (typeof fbq === "function") {
                fbq('track', 'Lead');
                console.log('Meta Pixel Lead event fired');
            } else {
                console.warn('Meta Pixel (fbq) not found');
            }
            if (typeof gtag === "function") {
                gtag('event', 'conversion', { 'send_to': 'AW-17046981478/KivwCJ-ZrMIaEOaW0cA_' });
                console.log('Google Ads conversion event fired');
            } else {
                console.warn('Google Ads tracking (gtag) not found');
            }
        }
        document.querySelector(".newsletter-error").style.display = "none";
    } else {
        document.querySelector(".newsletter-error").style.display = "block";
    }

    showResult();
});

quizOptionInput.forEach(function (option) {
  option.addEventListener("change", function () {
    const parent = option.closest(".quiz-step-wrapper");
    if (!parent.classList.contains("option-selected")) {
      parent.classList.add("option-selected");
    }
  });
});

function removeClass(_this) {
  const parentElement = _this.closest('.quiz-option-wrapper').querySelectorAll('.quiz-option button');
  if (parentElement.length > 0) {
    parentElement.forEach((el)=>{
      if(el.classList.contains('option-selected')){
        el.classList.remove('option-selected');
      }
    })
  }

}

// quizButton.forEach(function (button) {
//   button.addEventListener("click", function () {
//     removeClass(this)
//     if (button.dataset.value.toLowerCase() == "yes") {

//       const inputValue = button.dataset.value.toLowerCase();
//       let quizData = JSON.parse(sessionStorage.getItem("quizData")) || {};
//     if (inputValue) {
//       // Store input value for the step
//       quizData[`step_${customStep}`] = inputValue;
//       sessionStorage.setItem("quizData", JSON.stringify(quizData));
//     }
      
//       customStep += 1;
//       updateProgress(customStep);
//       button.classList.add('option-selected')
//       updateActiveTab(customStep);
//     } else {
//       // Generate buttons dynamically
//         stepsData.steps.forEach(step => {
//           if(customStep === step.step){ 
//             button.classList.add('option-selected')
//             showContent(step);
//           }
//         });
//     }
//   });
// });

quizButton.forEach(function (button) {
  button.addEventListener("click", function () {
    removeClass(this)
    const inputValue = button.dataset.value.toLowerCase();
      let quizData = JSON.parse(sessionStorage.getItem("quizData")) || {};
    if (inputValue) {
      // Store input value for the step
      quizData[`step_${customStep}`] = inputValue;
      sessionStorage.setItem("quizData", JSON.stringify(quizData));
    }
    customStep += 1;
      updateProgress(customStep);
      button.classList.add('option-selected')
      updateActiveTab(customStep);
  });
});


  const stepsData = {
            "steps": [
                { "step": 1, "content": "If you answered no, it means you're potentially exposing your family and home to harsh chemicals derived from petroleum. These chemicals can linger in the air and on surfaces, impacting indoor air quality and potentially causing skin irritation or other health concerns. Our 100% bio-based formula harnesses the power of plants for a truly clean and healthy home, without compromise." },
                { "step": 2, "content": "If you answered no, your cleaner relies on petrochemical-derived preservatives. These synthetic chemicals not only contribute to environmental pollution but can also be harsh on your home and health. Our plant-based preservatives offer effective cleaning power without the harmful side effects of petrochemicals, ensuring a cleaner home and a healthier planet." },
                { "step": 3, "content": "If you answered no, your cleaner contains added colorants and fragrances, even if they're plant-derived. While they might smell nice, these additives are a common source of allergies and sensitivities, especially for children and those with respiratory issues. Our fragrance-free and dye-free formula minimizes the risk of irritation, providing a truly pure clean. Our transparent formula focuses on what matters: powerful, plant-based cleaning ingredients without any hidden or unnecessary additions." },
                { "step": 4, "content": "If you answered no, you're likely paying more for water and contributing to plastic waste. Our concentrated formula allows you to create multiple bottles of cleaner from just one, saving you money and reducing your environmental footprint. Plus, you can easily adjust the strength for different cleaning tasks." },
                { "step": 5, "content": "Now, let's go beyond the basics and cover advanced topics." },
                { "step": 6, "content": "Congratulations! You've reached the final step." }
            ]
        };

// set height of the main container
function setHeight(step){
    const mainContainer = document.querySelector('.quiz-steps-container');
    const stepContainer = document.querySelector(`.quiz-step-${step.step}`);

    if(mainContainer && stepContainer){
      mainContainer.style.height = `${stepContainer.clientHeight}px`;
    }
}

  // Function to display step content
  function showContent(step) {
    const contentDiv = document.querySelector(`.quiz-step-${step.step} .quiz-option-wrapper`);
    if(document.querySelector(`.quiz-step-${step.step} .negative-response`)) return;
    contentDiv.insertAdjacentHTML('afterend', `<p class="negative-response">${step.content}</p>`);
    setHeight(step);
  }


prevButton.forEach((button) => {
  button.addEventListener("click", () => {
    const closestParent = button.closest(".quiz-step-wrapper");
    let stepNumber = parseInt(closestParent.dataset.step);
    if(customStep !== 1){ 
      customStep -= 1;
      updateProgress(stepNumber - 1);
      updateActiveTab(stepNumber - 1);
    }else{
      document.querySelector(".activation-hero-banner").style.display = "block";
      document.querySelector(".quiz-landing-page").style.display = "none";
    }
  });
});

nextButton.forEach((button) => {
  button.addEventListener("click", () => {
    const closestParent = button.closest(".quiz-step-wrapper");
    const tabNumber = parseInt(closestParent.dataset.step);
    if(closestParent.querySelector('.option-selected')){
      
    customStep += 1;
    const inputValue = closestParent.querySelector(".option-selected")?.textContent.trim();
    // Get existing session data or initialize an empty object
    let quizData = JSON.parse(sessionStorage.getItem("quizData")) || {};
    if (inputValue) {
      // Store input value for the step
      quizData[`step_${tabNumber}`] = inputValue;
      sessionStorage.setItem("quizData", JSON.stringify(quizData));
    }
    updateProgress(tabNumber + 1);
    updateActiveTab(tabNumber + 1, inputValue);
    }
  });
});

function updateActiveTab(tabNumber, inputValue) {
  // Update content visibility with slide transition
  tabContents.forEach((content, index) => {
    const tabIndex = parseInt(content.dataset.step);
    const tabType = content.dataset?.type;
    if (inputValue == "As general support for good health/looking for a good daily probiotic.") {
      optionType = "a";
    } else if (inputValue == "To address specific issue(s)") {
      optionType = "b";
    }
    if (tabIndex === tabNumber) {
      if (tabType) {
        if (optionType == tabType) {
          var contentHeight = content.scrollHeight;
          tabsContentWrapper.style.height = `${contentHeight}px`;
          content.classList.add("active");
          content.classList.remove("hidden-left", "hidden-right");
        } else {
          content.classList.remove("active");
        }
      } else {
        var contentHeight = content.scrollHeight;
        tabsContentWrapper.style.height = `${contentHeight}px`;
        content.classList.add("active");
        content.classList.remove("hidden-left", "hidden-right");
      }
    } else if (tabIndex < tabNumber) {
      content.classList.remove("active");
      content.classList.add("hidden-left");
    } else {
      content.classList.remove("active");
      content.classList.add("hidden-right");
    }
  });
  activeTab = tabNumber; // Update the active tab
}
function showResult() {
  const windowUrl = window.location.href;
  const quizObj = sessionStorage.getItem("quizData");

  if (windowUrl.indexOf("/pages/activation-offer") > -1 && quizObj) {
    const quizData = JSON.parse(quizObj);
    let yesCount = 1;

    Object.entries(quizData).forEach(([key, data]) => {
      if (data === "yes") {
        yesCount++;
      }
    });

    const quizWrapper = document.querySelector(".quiz-wrapper");

    if (quizWrapper) {
      quizWrapper.classList.add("show-products");

      const resultElements = document.querySelectorAll(`.quiz-product-main-product[data-result="${yesCount}"]`);
      const recommendedTitles = [];

      resultElements.forEach(result => {
        result.style.display = "block";
        const productName = result.querySelectorAll('.quiz-product-main-title h3');
        if (productName.length > 0) {
          productName.forEach((el)=>{
            recommendedTitles.push(el.textContent.trim());
          })
        }
      });

      // ✅ Send all quiz data and recommended product titles
      sendDataToKlaviyo(quizData, recommendedTitles);
    }
  }
}
